import React, { useState, useEffect } from 'react';
import { ITD, ITH, ITable, ITableBody, ITableHeader, ITableRow } from '../ITable';
import includes_search_string from '../../utils/includes_search_string';
import { Button, Card, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import general_fetch from '../../utils/fetch';
import { Checkbox } from 'antd';

const rule_type_struct = [
    {
        name: 'Automation Rules',
        id: 'design_automation'
    },
    {
        name: 'Manufacturing Rules',
        id: 'manufacturing_rule'
    },
    {
        name: 'Hardware Rules',
        id: 'hardware_rule'
    },
    {
        name: 'Design Constraint Rules',
        id: 'design_constraint'
    }
]


const RulesSelectionTableSingleRow = ({ rule, search_string, selection_map, on_toggle_rule}) => {
    const selectable = !!selection_map;
    const checked = selectable && !!selection_map[rule.id];
    const cell_style = selectable && !checked ? { color: '#b4bcc8' } : {};

    return (
        <ITableRow style={{ cursor: 'pointer', display: includes_search_string(rule.name, search_string) || includes_search_string(rule.description, search_string) ? '' : 'none' }} onClick={selectable ? () => on_toggle_rule(rule.id) : undefined}>
            <ITD>{selectable ? <span onClick={(e) => e.stopPropagation()}><Checkbox checked={checked} onChange={() => on_toggle_rule(rule.id)} /></span> : ''}</ITD>
            <ITD style={cell_style}>{rule.name}</ITD>
            <ITD style={cell_style}>{rule.description}</ITD>
        </ITableRow>
    )
}

const RulesSelectionTable = ({ rules, visibility, search_string, selection_map, on_toggle_rule, on_toggle_all, rule_type_name }) => {
    const selected_count = selection_map && rules ? rules.filter(x => selection_map[x.id]).length : 0;
    const total_count = rules ? rules.length : 0;

    return (
        <React.Fragment>
            {
                selection_map ?
                    <div onClick={() => { if (total_count) on_toggle_all(rules) }} style={{ display: visibility ? 'flex' : 'none', alignItems: 'center', justifyContent: 'space-between', gap: '12px', padding: '10px 18px', border: '1px solid #ccc', borderBottom: 0, backgroundColor: '#fafbfd', position: 'sticky', top: '-1.5rem', zIndex: 2, cursor: total_count ? 'pointer' : 'default', userSelect: 'none' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#32325d', fontWeight: 600 }}>
                            <span onClick={(e) => e.stopPropagation()}><Checkbox checked={total_count > 0 && selected_count === total_count} indeterminate={selected_count > 0 && selected_count < total_count} disabled={!total_count} onChange={() => on_toggle_all(rules)} /></span>
                            <span>Select all {rule_type_name}</span>
                        </div>
                        <span style={{ color: '#8898aa', fontSize: '13px' }}>{selected_count} of {total_count} selected</span>
                    </div>
                    : ''
            }
            <ITable rowSeparated={true} hover={true} bordered={true} style={selection_map ? { width: '100%' } : undefined} style_container={{ display: visibility ? 'block' : 'none' }}>
                <ITableHeader>
                    <ITH></ITH>
                    <ITH style={{ whiteSpace: 'nowrap' }}>Rule Name</ITH>
                    <ITH>Rule Description</ITH>
                </ITableHeader>
                <ITableBody>
                    {
                        rules && Array.isArray(rules) ? rules.map(rule => (
                            <RulesSelectionTableSingleRow key={rule.id} rule={rule} search_string={search_string} selection_map={selection_map} on_toggle_rule={on_toggle_rule} />
                        ))
                            : ''
                    }
                </ITableBody>
            </ITable>
        </React.Fragment>
    )
}

// mode 'apply' adds a checkbox per rule so CS can pick which rules to add to the org CT-15708
const ViewTemplateModal = ({ rules, open, handle_close, mode = 'view', template_names = [], store_name, on_apply}) => {
    const [active_rule_type, set_active_rule_type] = useState('design_automation');
    const [search_string, set_search_string] = useState('');
    const [rule_selection_map, set_rule_selection_map] = useState({});
    const is_apply_mode = mode === 'apply';

    // const alert = useAlert();
    // ['am, hw, dc, mf]

    // every rule starts selected each time the modal opens
    useEffect(() => {
        if (open && is_apply_mode) {
            let selection_map = {};
            (rules || []).forEach(rule => { selection_map[rule.id] = true });
            set_rule_selection_map(selection_map);
        }
    }, [open]);

    const on_click_handle_close = () => {
        set_active_rule_type('design_automation')
        handle_close()
    }

    const on_toggle_rule = (rule_id) => {
        set_rule_selection_map({ ...rule_selection_map, [rule_id]: !rule_selection_map[rule_id] });
    }

    const on_toggle_all = (tab_rules) => {
        const all_selected = tab_rules.every(rule => rule_selection_map[rule.id]);
        let selection_map = { ...rule_selection_map };
        tab_rules.forEach(rule => { selection_map[rule.id] = !all_selected });
        set_rule_selection_map(selection_map);
    }

    const selected_rule_ids = is_apply_mode && rules ? rules.filter(rule => rule_selection_map[rule.id]).map(rule => rule.id) : [];
    const selection_props = is_apply_mode ? { selection_map: rule_selection_map, on_toggle_rule, on_toggle_all } : {};

    const get_count_badge = (rule_type_id) => {
        const type_rules = rules ? rules.filter(x => x.type === rule_type_id) : [];
        const selected_count = type_rules.filter(x => rule_selection_map[x.id]).length;
        const is_active = active_rule_type === rule_type_id;
        const is_partial = selected_count < type_rules.length;
        const badge_style = is_active ? { backgroundColor: 'rgba(255,255,255,0.22)', color: '#fff' } : is_partial ? { backgroundColor: '#fff1e8', color: '#fb6340' } : { backgroundColor: 'rgba(94,114,228,0.1)', color: '#5e72e4' };
        return <span style={{ ...badge_style, marginLeft: '8px', fontSize: '12px', fontWeight: 600, padding: '1px 8px', borderRadius: '10px' }}>{selected_count}/{type_rules.length}</span>
    }

    return (
        <Modal centered size='xl' isOpen={open} toggle={on_click_handle_close}>
            <ModalHeader toggle={on_click_handle_close}>
                {
                    is_apply_mode ?
                        <React.Fragment>
                            Select rules to apply
                            <span style={{ display: 'block', marginTop: '4px', fontSize: '13px', fontWeight: 400, color: '#8898aa' }}>From <b style={{ color: '#525f7f', fontWeight: 600 }}>{template_names.join(', ')}</b>. Selected rules are added to {store_name || 'this org'} as inactive rules.</span>
                        </React.Fragment>
                        : 'Create New Inventory Template'
                }
            </ModalHeader>
            <ModalBody style={{ height: 'calc(100vh - 160px)', overflow: 'auto' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }} className='nav nav-pills mb-3'>
                    {
                        rule_type_struct.map(rule => (
                            <div key={rule.id} onClick={() => { set_active_rule_type(rule.id) }} className='nav-item' style={{ cursor: 'pointer' }}><a className={active_rule_type === rule.id ? 'nav-link active' : 'nav-link'} style={{ height: 'unset' }}> {rule.name} {is_apply_mode ? get_count_badge(rule.id) : ''}</a></div>
                        ))
                    }
                </div>
                <RulesSelectionTable rules={rules && rules.filter(x => x.type === 'design_automation')} visibility={active_rule_type === 'design_automation'} search_string={search_string} rule_type_name='Automation Rules' {...selection_props} />
                <RulesSelectionTable rules={rules && rules.filter(x => x.type === 'manufacturing_rule')} visibility={active_rule_type === 'manufacturing_rule'} search_string={search_string} rule_type_name='Manufacturing Rules' {...selection_props} />
                <RulesSelectionTable rules={rules && rules.filter(x => x.type === 'hardware_rule')} visibility={active_rule_type === 'hardware_rule'} search_string={search_string} rule_type_name='Hardware Rules' {...selection_props} />
                <RulesSelectionTable rules={rules && rules.filter(x => x.type === 'design_constraint')} visibility={active_rule_type === 'design_constraint'} search_string={search_string} rule_type_name='Design Constraint Rules' {...selection_props} />
            </ModalBody>

            <ModalFooter>
                {
                    is_apply_mode ?
                        <span style={{ marginRight: 'auto', color: '#8898aa' }}><b style={{ color: '#32325d' }}>{selected_rule_ids.length}</b> of {rules ? rules.length : 0} rules selected</span>
                        : ''
                }
                <Button className='white_button' onClick={on_click_handle_close}>{is_apply_mode ? 'Cancel' : 'Close'}</Button>
                {
                    is_apply_mode ?
                        <Button color='primary' disabled={!selected_rule_ids.length} onClick={() => on_apply(selected_rule_ids)}>{selected_rule_ids.length ? `Apply ${selected_rule_ids.length} rule${selected_rule_ids.length === 1 ? '' : 's'}` : 'Select rules to apply'}</Button>
                        : ''
                }
            </ModalFooter>
        </Modal>
    )
}

const InventoryTemplatesTableSingleRow = ({ template, template_selection_map, search_string='', onClickViewRule}) => {
    const [checked, set_checked] = useState(false);

    const onCheckChange = (e) => {
            e.stopPropagation();
            set_checked(!checked);
    }

    useEffect(() => {
        template_selection_map[template.id] = checked;
    }, [checked]);
    return (
        <ITableRow style={{ cursor: 'pointer', display: includes_search_string(template.name, search_string) ? '' : 'none' }} onClick={onCheckChange}>
            <ITD><Checkbox checked={checked} onChange={onCheckChange} /></ITD>
            {/* <ITD>{idx + 1}</ITD> */}
            <ITD>{template.name}</ITD>
            <ITD onClick={(e) => { e.stopPropagation(); onClickViewRule(template.id) }}>Click to view</ITD>
            <ITD></ITD>
        </ITableRow>
    )
}

const InventoryTemplatesTable = ({ templates, search_string, template_selection_map }) => {
    const [active_template_id, set_active_template_id] = useState('');

    const onClickViewRule = (template_id) => {
        set_active_template_id(template_id)
    }

    const closeViewRuleModal = () => {
        set_active_template_id('')
    }

    return (
        <React.Fragment>
            {/* all_rules && Array.isArray(all_rules) && active_template_id && templates[active_template_id] && templates[active_template_id].automation_rule_ids ? all_rules.filter(x => templates[active_template_id].automation_rule_ids.includes(x.id)) : [] */}
            <ViewTemplateModal rules={active_template_id && templates[active_template_id] ? templates[active_template_id].automation_rules : []} open={active_template_id} handle_close={closeViewRuleModal} />
            <ITable rowSeparated={true} hover={true} style_container={{borderTop: '1px solid  var(--light-border-color', borderBottom: '1px solid  var(--light-border-color', flex: 1, minHeight: '40px', overflow: 'auto'}}>
                <ITableHeader>
                    <ITH></ITH>
                    {/* <ITH>S.No</ITH> */}
                    <ITH style={{ whiteSpace: 'nowrap' }}>Template Name</ITH>
                    <ITH></ITH>
                </ITableHeader>
                <ITableBody>
                    {
                        templates && Object.keys(templates) ? Object.keys(templates).map((template_id, idx) => (
                            <InventoryTemplatesTableSingleRow key={template_id} template={templates[template_id]} template_selection_map={template_selection_map} onClickViewRule={onClickViewRule}/>
                        ))
                            : ''
                    }
                </ITableBody>
            </ITable>
        </React.Fragment>

    )
}

const InventoryTemplates = ({store_info, user_details, set_page_loader}) => {
    const [all_inventory_templates, set_all_inventory_templates] = useState({});
    const [template_selection_map, set_template_selection_map] = useState({});
    const [apply_modal_data, set_apply_modal_data] = useState(null);

    const get_all_inventory_templates = async () => {
        try {
            let response = await general_fetch({ url: 'inventory_template/get' });
            return response;
    
        } catch (err) {
            console.log("Error getting inventory templates", err);
            return Promise.reject({ ...err, info: 'Error getting inventory templates' })
        }
    }

    const apply_inventory_templates = async (body) => {
        try {
            let response = await general_fetch({ url: 'inventory_template/apply', body });
            return response;
    
        } catch (err) {
            console.log("Error applying inventory templates", err);
            return Promise.reject({ ...err, info: 'Error applying inventory templates' })
        }
    }

    const fetch_all_inventory_templates = async () => {
        try {
            let inventory_templates = await get_all_inventory_templates();
            // debug_log("Inventory Templates - ", inventory_templates);
            set_all_inventory_templates(inventory_templates)
        } catch (err) {
            toastr.error("Error fetching automation rules. Try again in sometime")
        }
    }

    const open_apply_modal = () => {
        let inventory_template_ids = Object.keys(template_selection_map).filter(id => template_selection_map[id])
        if (!inventory_template_ids.length) {
            toastr.error("Select at least one template to apply")
            return
        }
        let rules = [], seen_rule_ids = {};
        inventory_template_ids.forEach(id => {
            let template = all_inventory_templates[id];
            (template && template.automation_rules ? template.automation_rules : []).forEach(rule => {
                if (rule && !seen_rule_ids[rule.id]) {
                    seen_rule_ids[rule.id] = true;
                    rules.push(rule);
                }
            });
        });
        let template_names = inventory_template_ids.map(id => all_inventory_templates[id] ? all_inventory_templates[id].name : '').filter(name => name);
        set_apply_modal_data({ rules, template_names });
    }

    const applyInventoryTemplates = async (automation_rule_ids) => {
        set_page_loader(true, "Applying Template")
        // if (dataValidation()) {
            try {
                let inventory_template_ids = Object.keys(template_selection_map).filter(id => template_selection_map[id])
                let data = { inventory_template_ids, automation_rule_ids }
                // todo - Select a BU for applying the templates
                data["customer_business_unit_id"] = store_info.default_business_unit_id;
                data["cs_user_id"] = user_details.id;
                console.log("Rule Data on Inventory Template Apply ", data)
                await apply_inventory_templates(data);
                toastr.success("Inventory Template applied successfully")
                set_apply_modal_data(null)
                // on_click_handle_close()
                // fetch_all_inventory_templates()
            } catch (err) {
                toastr.error("Could not apply inventory template. Please try again later.")
            }
        set_page_loader(false)
        // }
    }

    useEffect(() => {
        fetch_all_inventory_templates()
    }, []);



    return (
        <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className='mb-3 px-2' style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <div>Rule Wizard</div>
                <Button color='primary' onClick={open_apply_modal}>Apply Templates</Button>
            </div>
            <ViewTemplateModal mode='apply' rules={apply_modal_data ? apply_modal_data.rules : []} open={!!apply_modal_data} template_names={apply_modal_data ? apply_modal_data.template_names : []} store_name={store_info && store_info.name} handle_close={() => set_apply_modal_data(null)} on_apply={applyInventoryTemplates} />
            <InventoryTemplatesTable templates={all_inventory_templates} search_string={''} template_selection_map={template_selection_map}/>
        </div>
    )
}

export default InventoryTemplates